<template>
    <div>
        <header class="major">
            <h2>Unsere UnterstützerInnen</h2>
            <div>Für die Unterstützung danken wir den vielen PrivatspenderInnen, unseren FörderInnen und UnterstützerInnen.</div>
        </header>

        <section class="posts posts border-top-none">
            <article v-for="(s,index) in supporter" :key="index">
                <a v-if="s.link" :href="s.link" target="_blank" class="noBoarder"><img :alt="s.name" :title="s.name" border="0" :src="s.img" width="200px" /></a>
                <img v-else :alt="s.name" :title="s.name" border="0" :src="s.img" width="200px" />
            </article>
        </section>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                supporter:[
                    {
                        name:"Leuchtturm Jena",
                        link:"https://leuchtturm-coworking.de",
                        img:"/images/supporter/LT.png"
                    },/*
                    {
                        name:"etracker",
                        link:"https://www.etracker.com/",
                        img:"/images/supporter/etracker.jpg"
                    },*/
                    {
                        name:"UV Concept Gmbh",
                        link:"https://uvconcept.com/",
                        img:"/images/supporter/uv-concept.png"
                    },
                    {
                        name:"dieUmwelt Drucker",
                        img:"/images/supporter/umweltdruckerei.png",
                        link:"https://www.dieumweltdruckerei.de"
                    }
                ]
            }
        },
        
    }
</script>

<style lang="scss" scoped>
.noBoarder{
    border-bottom: none;
}
</style>